import { render, staticRenderFns } from "./taxonomy.vue?vue&type=template&id=de50c3f0&"
import script from "./taxonomy.vue?vue&type=script&lang=js&"
export * from "./taxonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports